export const checkOS = () => {
  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('android') > -1) {
    return 'android';
  } else if (agent.indexOf('iphone') > -1 || agent.indexOf('ipad') > -1 || agent.indexOf('ipod') > -1) {
    return 'ios';
  }
  return 'other';
};
